<template>
    <div style="width: 100%; height: 100vh; overflow: hidden;">

    </div>
</template>

<script>
export default {
    name: '',
    methods: {

    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/page/zone/index.vue